var map = {
	"./anniversary.svg": "307c",
	"./default.svg": "aaef",
	"./geopolitical.svg": "02f5",
	"./holiday.svg": "8c7d",
	"./military.svg": "43b8",
	"./other.svg": "944b",
	"./political_election.svg": "2c77",
	"./political_other.svg": "794e",
	"./security.svg": "2b81",
	"./severe_weather.svg": "3fac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9274";